import React from "react";
import { Instagram, Facebook, Twitter, MessageCircle } from "lucide-react";
import { WA_NUMBER } from "../mock";

const Footer = () => {
  return (
    <footer className="mt-24 pb-8 hidden md:block">
      <div className="max-w-6xl mx-auto px-4">
        <div className="bg-[#004743] rounded-[2.5rem] p-8 md:p-12 text-white relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#0E8A77]/20 rounded-full blur-3xl" />
          <div className="absolute -bottom-24 -left-10 w-64 h-64 bg-[#FFD66B]/10 rounded-full blur-3xl" />

          <div className="relative grid md:grid-cols-3 gap-10">
            <div>
              <div className="flex items-center mb-4">
                <img
                  src="/logo-white.png"
                  alt="ruangrasa"
                  className="h-9 w-auto"
                />
              </div>
              <p className="text-white/70 text-sm leading-relaxed">
                Toko hiasan dinding terbaik untuk setiap ruang. Setiap produk
                dikurasi sepenuh hati agar dindingmu ikut bercerita.
              </p>
              <div className="flex gap-2 mt-5">
                {[Instagram, Facebook, Twitter].map((Icon, i) => (
                  <button
                    key={i}
                    className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center transition-colors duration-200"
                  >
                    <Icon className="w-4 h-4" />
                  </button>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-bold mb-4 text-[#9FD8CB]">Menu</h4>
              <ul className="space-y-2.5 text-sm text-white/70">
                {["Beranda", "Produk", "Kenapa Kami", "Testimoni"].map((m) => (
                  <li key={m}>
                    <span className="hover:text-white cursor-pointer transition-colors">
                      {m}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-bold mb-4 text-[#9FD8CB]">Hubungi Kami</h4>
              <p className="text-sm text-white/70 mb-4">
                Ada pertanyaan? Chat admin kami langsung via WhatsApp, fast
                respon setiap hari 08.00 - 21.00 WIB.
              </p>
              <a
                href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
                  "Halo ruangrasa! Saya mau bertanya tentang produk."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#0E8A77] hover:bg-[#0B7A68] text-white px-5 py-2.5 rounded-full text-sm font-bold transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-green-400/30"
              >
                <MessageCircle className="w-4 h-4" />
                Dea - Admin ruangrasa
              </a>
            </div>
          </div>

          <div className="relative border-t border-white/10 mt-10 pt-6 text-center text-xs text-white/50">
            © 2026 ruangrasa. Dibuat dengan sepenuh hati.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
